import React from "react";
import styled from "styled-components";
import { Route, Switch } from "react-router-dom";
import ROUTES, { EKYC } from "../../../helpers/constants/routes";
import ParentUiCompoent from "../../login/componentLoginScreen/parentUiCompoent";
import LoginPage from "./EkycLogin";
import VerifyOTPPage from "./VerifyOtp";
import themeSizes from "../../../theme/themeSizes";
import RetailLogoPage from "../../../components/RetailLogoPage";
import { getDeviceType } from "../../../utils/CommonFunction";
import { DeviceType } from "../../../helpers/constants/constant";
import LoginScreenImage from "./login-screen-image.png";
import VerifyCouponCode from "./VerifyCouponCode";
import CouponUserDetails from "./CouponUserDetails";
import VerifyOTPAndLogin from "./VerifyOTPAndLogin";
import SetAccountPassword from "./SetAccountPassword";
import PasswordSuccessScreen from "./PasswordSuccessScreen";
import EMyTrackPasswordLogin from "./EMyTrackPasswordLogin";
import CouponCodeMobileForgotPassword from "./CouponCodeMobileForgotPassword";

export const LoginStyle = styled.div`
  display: flex;
  section {
    width: 100%;
  }
  & > section:first-child {
    background: linear-gradient(0deg, #4770c1, #4770c1);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  height: 100vh;

  @media ${themeSizes.mobile} {
    flex-flow: column;
    &>section:first-child{
        background: ${(props) => (props.loginRoute ? (props.setBackGround ? "none" : "white") : "linear-gradient(0deg, #4770C1, #4770C1)")};
}
`;

const MobileLayoutWrapper = ({ children }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#F0F4FA",
        paddingBottom: "40px",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          padding: "45px 40px 50px 40px",
          alignItems: "center",
          background: "linear-gradient(135deg, #1e3c72 0%, #4770C1 100%)",
          borderBottomRightRadius: "24px",
          borderBottomLeftRadius: "24px",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
        }}
      >
        <img
          src={LoginScreenImage}
          alt="logo"
          height="120px"
          width="120px"
          style={{ filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.15))" }}
        />
      </div>
      {children}
    </div>
  );
};

export const Login = () => {
  const isMobile =
    getDeviceType() === DeviceType.MOBILE ||
    getDeviceType() === DeviceType.TABLET;

  return (
    <Switch>
      <Route
        path={EKYC.LOGIN}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <LoginPage />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <LoginPage />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.OTP}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <VerifyOTPPage />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <VerifyOTPPage />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.COUPON_LOGIN}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <VerifyCouponCode />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <VerifyCouponCode />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.COUPON_USER_DETAILS}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <CouponUserDetails />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <CouponUserDetails />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.VERIFYOTPANDLOGIN}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <VerifyOTPAndLogin />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <VerifyOTPAndLogin />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.SET_ACCOUNT_PASSWORD}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <SetAccountPassword />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <SetAccountPassword />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.PASSWORD_SUCCESS}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <PasswordSuccessScreen />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <PasswordSuccessScreen />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.PASSWORD_LOGIN}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <EMyTrackPasswordLogin />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <EMyTrackPasswordLogin />
            </ParentUiCompoent>
          )
        }
      />

      <Route
        path={EKYC.COUPON_CODE_MOBILEFORGOTPASSWORD}
        exact
        render={() =>
          isMobile ? (
            <MobileLayoutWrapper>
              <CouponCodeMobileForgotPassword />
            </MobileLayoutWrapper>
          ) : (
            <ParentUiCompoent>
              <CouponCodeMobileForgotPassword />
            </ParentUiCompoent>
          )
        }
      />
    </Switch>
  );
};

export default Login;
